<div *ngIf="!isAdmin" class="row">
  <div class="col-12">
    <nb-card>
      <nb-card-body class="text-center" style="padding: 40px">
        <nb-icon icon="lock-outline" style="font-size: 48px; color: #888"></nb-icon>
        <h4 style="margin-top: 16px">Not Authorized</h4>
        <p class="text-muted">SSO Applications management is restricted to administrators.</p>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<div *ngIf="isAdmin">
  <div class="row">
    <div class="col-sm-6">
      <h2>SSO Applications</h2>
    </div>
    <div class="col-sm-6">
      <button type="button" class="btn btn-primary px-4" style="float: right" (click)="openCreateDialog()">
        + New Application
      </button>
    </div>
  </div>

  <div class="col-12" style="margin-top: 20px">
    <nb-card>
      <nb-card-body>
        <table class="table text-center">
          <thead>
            <tr>
              <th scope="col">S.No.</th>
              <th scope="col">Name</th>
              <th scope="col">Client ID</th>
              <th scope="col">Allowed Roles</th>
              <th scope="col">Status</th>
              <th scope="col">Created</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let app of applications
                  | paginate: { itemsPerPage: count, currentPage: page, totalItems: total };
                let i = index
              "
            >
              <td>{{ (page - 1) * count + i + 1 }}</td>
              <td>
                <strong>{{ app.name }}</strong>
                <br />
                <small *ngIf="app.description" class="text-muted">{{ app.description }}</small>
              </td>
              <td>
                <code class="client-id" [nbTooltip]="app.clientId">{{ truncateClientId(app.clientId) }}</code>
                <nb-icon
                  style="cursor: pointer; margin-left: 4px"
                  (click)="copyClientId(app.clientId)"
                  icon="copy-outline"
                  nbTooltip="Copy Client ID"
                ></nb-icon>
              </td>
              <td>
                <span *ngFor="let role of formatRoles(app.allowedRoles)" class="role-chip">
                  {{ role }}
                </span>
              </td>
              <td>
                <nb-badge
                  [text]="isActive(app) ? 'Active' : 'Revoked'"
                  [status]="isActive(app) ? 'success' : 'danger'"
                ></nb-badge>
              </td>
              <td>{{ formatCreatedAt(app.createdAt) }}</td>
              <td>
                <nb-icon
                  style="cursor: pointer"
                  (click)="openEditDialog(app)"
                  class="right"
                  icon="edit-2-outline"
                  nbTooltip="View / Edit"
                ></nb-icon>
                <nb-icon
                  style="cursor: pointer"
                  (click)="rotateSecret(app)"
                  class="right"
                  icon="refresh-outline"
                  nbTooltip="Rotate Secret"
                ></nb-icon>
                <nb-icon
                  *ngIf="isActive(app)"
                  style="cursor: pointer"
                  (click)="revokeApplication(app)"
                  class="right deleteIcon"
                  icon="slash-outline"
                  nbTooltip="Revoke Application"
                ></nb-icon>
                <nb-icon
                  *ngIf="!isActive(app)"
                  style="cursor: pointer"
                  (click)="activateApplication(app)"
                  class="right activateIcon"
                  icon="checkmark-circle-outline"
                  nbTooltip="Activate Application"
                ></nb-icon>
              </td>
            </tr>
            <tr *ngIf="applications.length === 0">
              <td colspan="7" class="text-center" style="padding: 30px; color: #888">
                No SSO applications found. Click "+ New Application" to create one.
              </td>
            </tr>
          </tbody>
        </table>
        <pagination-controls
          class="pagination"
          [responsive]="true"
          (pageChange)="pageChanged($event)"
          previousLabel="Prev"
          nextLabel="Next"
        ></pagination-controls>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus">
  <p style="color: white">Loading...</p>
</ngx-spinner>
